import { HealthcareProviderPatientsWithDiagnosisStatisticsCreateCommand } from '@dreryk/egabinet-statistics-frontend-api';
import { Icd10Code } from '@dreryk/egabinet-icd-dictionary-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ModalConfirmButton } from '@dreryk/react-components';
import { Range } from '@dreryk/watermelon';

import { statisticsTranslationKeys } from '../../../translations';
import {
   GenerateHealthcareProviderPatientsWithDiagnosisFormBean,
   GenerateHealthcareProviderPatientsWithDiagnosisFormController,
} from '../GenerateHealthcareProviderPatientsWithDiagnosisForm.types';

export type GenerateHealthcareProviderPatientsWithDiagnosisStatisticsButtonProps = Pick<
   GenerateHealthcareProviderPatientsWithDiagnosisFormController,
   'handleSubmit'
> & {
   readonly onSuccess: VoidFunction;
};

export const GenerateHealthcareProviderPatientsWithDiagnosisStatisticsButton = (
   props: GenerateHealthcareProviderPatientsWithDiagnosisStatisticsButtonProps
): JSX.Element => {
   const { executeAsync: createStatistics } = useCqrsCommand<
      void,
      GenerateHealthcareProviderPatientsWithDiagnosisFormBean
   >(
      (parameters) => {
         const command = new HealthcareProviderPatientsWithDiagnosisStatisticsCreateCommand();
         command.icd10Code = Icd10Code.of(parameters.diagnosis!.code);
         command.dateRange = Range.closed(parameters.from, parameters.to);
         return command;
      },
      {
         onSuccess: () => {
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         label={statisticsTranslationKeys.modal.submit}
         onClick={props.handleSubmit(createStatistics)}
      />
   );
};
